import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../constant/reportType";
import { Button } from "react-bootstrap";
import { Switch, Table } from "antd";
import { DEPARTMENT_MASTER_COLUMN, KRA_MASTER_COLUMN, PHASE_MASTER_COLUMN, PROJECT_MASTER_COLUMN, PROJECT_PHASE_ACTIVITY_COLUMN, PROJECT_TYPE_MASTER_COLUMN, PROJECT_USER_MASTER_COLUMN, TIME_SHEET_COLUMN, USER_COLUMN } from "../../constant/AppConstant";
import { BsPencilSquare, BsPlus } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import MasterReportData from "./MasterReportData";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { useDeleteDepartmentMasterMutation, useFindAllDepartmentMasterMutation, useGetAllDepartmentMasterMutation, useGetAllDepartmentMasterWithSearchMutation } from "../../redux-toolkit/services/departmentMasterService";
import { allDepartmentMasterDetails, getAllDepartmentMasterDetails, getDepartmentMasterTotalRecords, setAllDepartmentMaster, setDepartmentMaster } from "../../redux-toolkit/slices/departmentMasterSlice";
import { useDeleteProjectMasterMutation, useFindAllProjectMasterMutation, useGetAllProjectMasterMutation, useGetAllProjectMasterWithSearchMutation } from "../../redux-toolkit/services/projectMasterService";
import { allProjectMasterDetails, getAllProjectMasterDetails, getProjectMasterTotalRecords, setAllProjectMaster, setProjectMaster } from "../../redux-toolkit/slices/projectMasterSlice";
import { useDeleteProjectTypeMasterMutation, useFindAllProjectTypeMasterMutation, useGetAllProjectTypeMasterMutation } from "../../redux-toolkit/services/projectTypeMasterService";
import { useDeletePhaseMasterMutation, useGetAllPhaseMasterMutation } from "../../redux-toolkit/services/phaseMasterService";
import { allProjectTypeMasterDetails, getAllProjectTypeMasterDetails, getProjectTypeMasterTotalRecords, setAllProjectTypeMaster, setProjectTypeMaster } from "../../redux-toolkit/slices/projectTypeMasterSlice";
import { getAllPhaseMasterDetails, getPhaseMasterTotalRecords, setPhaseMaster } from "../../redux-toolkit/slices/phaseMasterSlice";
import { useDeleteProjectUserMasterMutation, useGetAllProjectUserMasterMutation } from "../../redux-toolkit/services/projectUserMasterService";
import { getAllProjectUserMasterDetails, getProjectUserMasterTotalRecords, setProjectUserMaster } from "../../redux-toolkit/slices/projectUserMasterSlice";
import { useDeleteProjectPhaseActivityMutation, useGetAllProjectPhaseActivityMutation } from "../../redux-toolkit/services/projectPhaseActivityService";
import { getAllProjectPhaseActivityDetails, getProjectPhaseActivityTotalRecords, setProjectPhaseActivity } from "../../redux-toolkit/slices/projectPhaseActivitySlice";
import { useDeleteKRAMasterMutation, useFindAllKRAMasterMutation, useGetAllKRAMasterMutation } from "../../redux-toolkit/services/kRAMasterService";
import { getAllKRAMasterDetails, getKRAMasterTotalRecords, setAllKRAMaster, setKRAMaster } from "../../redux-toolkit/slices/kRAMasterSlice";
import { useDeleteTimeSheetMutation, useFilterTimeSheetsMutation, useFindAllMentorsMutation, useGetAllTimeSheetMutation } from "../../redux-toolkit/services/timeSheetService";
import { allMentorsDetails, getAllTimeSheetDetails, getTimeSheetTotalRecords, setAllMentors, setFilteredData, setTimeSheet } from "../../redux-toolkit/slices/timeSheetSlice";
import { useFindAllOrganizationMasterMutation } from "../../redux-toolkit/services/organizationMasterService";
import { allOrganizationMasterDetails, setAllOrganizationMaster } from "../../redux-toolkit/slices/organizationMasterSlice";

type Props = {};
const AllMasterReports = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localUserObj: any = getLocalStorageData("localUser");

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [sponsorData, setSponsorData] = useState([]);
    const [searchFields, setSearchFields] = useState({
        department: "",
        organizationName: "",
        projectMentor: "",
        projectType: "",
        sponsor: "",
    });

    //getMutations
    const [getAllDepartmentMaster, departmentMasterResponse] = useGetAllDepartmentMasterMutation();
    const [getAllProjectMaster, projectMasterResponse] = useGetAllProjectMasterMutation();
    const [getAllProjectTypeMaster, projectTypeMasterResponse] = useGetAllProjectTypeMasterMutation();
    const [getAllPhaseMaster, phaseMasterResponse] = useGetAllPhaseMasterMutation();
    const [getAllProjectUserMaster, projectUserMasterResponse] = useGetAllProjectUserMasterMutation();
    const [getAllProjectPhaseActivity, projectPhaseActivityResponse] = useGetAllProjectPhaseActivityMutation();
    const [getAllKRaMaster, kRaMasterResponse] = useGetAllKRAMasterMutation();
    const [getAllTimeSheet, timeSheetResponse] = useGetAllTimeSheetMutation();
    const [getFilteredTimeSheet, filteredTimeSheetResponse] = useFilterTimeSheetsMutation();

    const [getAllOrganizations, allOrganizationsResponse] = useFindAllOrganizationMasterMutation();
    const [findAllDepartmentMaster, findAllDepartmentMasterResponse] = useFindAllDepartmentMasterMutation();
    const [findAllProjectTypeMaster, findAllProjectTypeMasterResponse] = useFindAllProjectTypeMasterMutation();
    const [findAllProjectMaster, findAllProjectMasterResponse] = useFindAllProjectMasterMutation();
    const [findAllMenotrs, findAllMenotrsResponse] = useFindAllMentorsMutation();
    const [findAllKRAMaster, findAllKRAMasterResponse] = useFindAllKRAMasterMutation();
    //delete mutation
    const [deleteDepartmentMaster, deleteDepartmentMasterResponse] = useDeleteDepartmentMasterMutation();
    const [deleteProjectMaster, deleteProjectMasterResponse] = useDeleteProjectMasterMutation();
    const [deleteProjectTypeMaster, deleteProjectTypeMasterResponse] = useDeleteProjectTypeMasterMutation();
    const [deletePhaseMaster, deletePhaseMasterResponse] = useDeletePhaseMasterMutation();
    const [deleteProjectUserMaster, deleteProjectUserMasterResponse] = useDeleteProjectUserMasterMutation();
    const [deleteProjectPhaseActivity, deleteProjectPhaseActivityResponse] = useDeleteProjectPhaseActivityMutation();
    const [deleteKRaMaster, deleteKRaMasterResponse] = useDeleteKRAMasterMutation();
    const [deleteTimeSheet, deleteTimeSheetResponse] = useDeleteTimeSheetMutation();

    //totalRecords
    const totalDepartmentMaster: any = useAppSelector(getDepartmentMasterTotalRecords);
    const totalProjectMaster: any = useAppSelector(getProjectMasterTotalRecords);
    const totalProjectTypeMaster: any = useAppSelector(getProjectTypeMasterTotalRecords);
    const totalPhaseMaster: any = useAppSelector(getPhaseMasterTotalRecords);
    const totalProjectUserMaster: any = useAppSelector(getProjectUserMasterTotalRecords);
    const totalProjectPhaseActivity: any = useAppSelector(getProjectPhaseActivityTotalRecords);
    const totalKRAMaster: any = useAppSelector(getKRAMasterTotalRecords);
    const totalTimeSheet: any = useAppSelector(getTimeSheetTotalRecords);

    //selector
    const departmentMasterData: any = useAppSelector(getAllDepartmentMasterDetails);
    const projectMasterData: any = useAppSelector(getAllProjectMasterDetails);
    const projectTypeMasterData: any = useAppSelector(getAllProjectTypeMasterDetails);
    const phaseMasterData: any = useAppSelector(getAllPhaseMasterDetails);
    const projectUserMasterData: any = useAppSelector(getAllProjectUserMasterDetails);
    const projectPhaseActivityData: any = useAppSelector(getAllProjectPhaseActivityDetails);
    const kRAMasterData: any = useAppSelector(getAllKRAMasterDetails);
    const timeSheetData: any = useAppSelector(getAllTimeSheetDetails);

    const organizationData: any = useAppSelector(allOrganizationMasterDetails);
    const allDepartment: any = useAppSelector(allDepartmentMasterDetails);
    const allProjectType: any = useAppSelector(allProjectTypeMasterDetails);
    const allProject: any = useAppSelector(allProjectMasterDetails);
    const allMentors: any = useAppSelector(allMentorsDetails);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.DEPARTMENT_MASTER:
                setReportName(REPORT_NAME.DEPARTMENT_MASTER)
                break;
            case REPORT_PATH.PROJECT_MASTER:
                setReportName(REPORT_NAME.PROJECT_MASTER)
                break;
            case REPORT_PATH.PROJECT_USER_MASTER:
                setReportName(REPORT_NAME.PROJECT_USER_MASTER)
                break;
            case REPORT_PATH.PROJECT_TYPE_MASTER:
                setReportName(REPORT_NAME.PROJECT_TYPE_MASTER)
                break;
            case REPORT_PATH.PHASE_MASTER:
                setReportName(REPORT_NAME.PHASE_MASTER)
                break;
            case REPORT_PATH.PROJECT_PHASE_ACTIVITY:
                setReportName(REPORT_NAME.PROJECT_PHASE_ACTIVITY)
                break;
            case REPORT_PATH.KRA_MASTER:
                setReportName(REPORT_NAME.KRA_MASTER)
                break;
            case REPORT_PATH.TIME_SHEET:
                setReportName(REPORT_NAME.TIME_SHEET)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isEnabled === true ? "bg-danger" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isEnabled === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isEnabled === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.DEPARTMENT_MASTER && DEPARTMENT_MASTER_COLUMN) {
            DEPARTMENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.PROJECT_MASTER && PROJECT_MASTER_COLUMN) {
            PROJECT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.PROJECT_USER_MASTER && PROJECT_USER_MASTER_COLUMN) {
            PROJECT_USER_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.PROJECT_TYPE_MASTER && PROJECT_TYPE_MASTER_COLUMN) {
            PROJECT_TYPE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.PHASE_MASTER && PHASE_MASTER_COLUMN) {
            PHASE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY && PROJECT_PHASE_ACTIVITY_COLUMN) {
            PROJECT_PHASE_ACTIVITY_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.KRA_MASTER && KRA_MASTER_COLUMN) {
            KRA_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.TIME_SHEET && TIME_SHEET_COLUMN) {
            TIME_SHEET_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            getAllDepartmentMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_MASTER) {
            getAllProjectMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_USER_MASTER) {
            getAllProjectUserMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
            getAllProjectTypeMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PHASE_MASTER) {
            getAllPhaseMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
            getAllProjectPhaseActivity({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.KRA_MASTER) {
            getAllKRaMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.TIME_SHEET) {
            getAllOrganizations({ token: localUserObj.token })
            findAllDepartmentMaster({ token: localUserObj.token })
            findAllProjectTypeMaster({ token: localUserObj.token })
            findAllProjectMaster({ token: localUserObj.token })
            findAllMenotrs({ token: localUserObj.token })
            findAllKRAMaster({ token: localUserObj.token })
            getAllTimeSheet({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
                getAllDepartmentMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.PROJECT_MASTER) {
                getAllProjectMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.PROJECT_USER_MASTER) {
                getAllProjectUserMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
                getAllProjectTypeMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.PHASE_MASTER) {
                getAllPhaseMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
                getAllProjectPhaseActivity({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.KRA_MASTER) {
                getAllKRaMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.TIME_SHEET) {
                getAllTimeSheet({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            getAllDepartmentMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_MASTER) {
            getAllProjectMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_USER_MASTER) {
            getAllProjectUserMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
            getAllProjectTypeMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PHASE_MASTER) {
            getAllPhaseMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
            getAllProjectPhaseActivity({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.KRA_MASTER) {
            getAllKRaMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.TIME_SHEET) {
            getAllTimeSheet({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    //delete..........
    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            deleteDepartmentMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.PROJECT_MASTER) {
            deleteProjectMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.PROJECT_USER_MASTER) {
            deleteProjectUserMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
            deleteProjectTypeMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.PHASE_MASTER) {
            deletePhaseMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
            deleteProjectPhaseActivity({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.KRA_MASTER) {
            deleteKRaMaster({
                id: record.id,
                token: localUserObj.token
            })
        } else if (reportName === REPORT_NAME.TIME_SHEET) {
            deleteTimeSheet({
                id: record.id,
                token: localUserObj.token
            })
        }
    };

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    //get allDimensionMaster.......
    useEffect(() => {
        if (departmentMasterResponse.isSuccess) {
            dispatch(setDepartmentMaster(departmentMasterResponse));
        } else if (departmentMasterResponse.isError) {
            alertMessage("Error while fetching department master", "error");
            setDatasource([]);
        }
    }, [departmentMasterResponse.isSuccess, departmentMasterResponse.isError]);

    //get allProjectMaster.......
    useEffect(() => {
        if (projectMasterResponse.isSuccess) {
            dispatch(setProjectMaster(projectMasterResponse));
        } else if (projectMasterResponse.isError) {
            alertMessage("Error while fetching project master", "error");
            setDatasource([]);
        }
    }, [projectMasterResponse.isSuccess, projectMasterResponse.isError]);

    useEffect(() => {
        if (projectTypeMasterResponse.isSuccess) {
            dispatch(setProjectTypeMaster(projectTypeMasterResponse));
        } else if (projectTypeMasterResponse.isError) {
            alertMessage("Error while fetching project type master", "error");
            setDatasource([]);
        }
    }, [projectTypeMasterResponse.isSuccess, projectTypeMasterResponse.isError]);

    useEffect(() => {
        if (phaseMasterResponse.isSuccess) {
            dispatch(setPhaseMaster(phaseMasterResponse));
        } else if (phaseMasterResponse.isError) {
            alertMessage("Error while fetching phase master", "error");
            setDatasource([]);
        }
    }, [phaseMasterResponse.isSuccess, phaseMasterResponse.isError]);

    useEffect(() => {
        if (projectUserMasterResponse.isSuccess) {
            dispatch(setProjectUserMaster(projectUserMasterResponse));
        } else if (projectUserMasterResponse.isError) {
            alertMessage("Error while fetching project use master", "error");
            setDatasource([]);
        }
    }, [projectUserMasterResponse.isSuccess, projectUserMasterResponse.isError]);


    useEffect(() => {
        if (projectPhaseActivityResponse.isSuccess) {
            dispatch(setProjectPhaseActivity(projectPhaseActivityResponse));
        } else if (projectPhaseActivityResponse.isError) {
            alertMessage("Error while fetching project phase activity", "error");
            setDatasource([]);
        }
    }, [projectPhaseActivityResponse.isSuccess, projectPhaseActivityResponse.isError]);

    useEffect(() => {
        if (kRaMasterResponse.isSuccess) {
            dispatch(setKRAMaster(kRaMasterResponse));
        } else if (kRaMasterResponse.isError) {
            alertMessage("Error while fetching key result area master", "error");
            setDatasource([]);
        }
    }, [kRaMasterResponse.isSuccess, kRaMasterResponse.isError]);

    useEffect(() => {
        if (timeSheetResponse.isSuccess) {
            dispatch(setTimeSheet(timeSheetResponse.data));
        } else if (timeSheetResponse.isError) {
            alertMessage("Error while fetching time sheet data", "error");
            setDatasource([]);
        }
    }, [timeSheetResponse.isSuccess, timeSheetResponse.isError]);

    useEffect(() => {
        if (allOrganizationsResponse.isSuccess) {
            dispatch(setAllOrganizationMaster(allOrganizationsResponse));
        } else if (allOrganizationsResponse.isError) {
            alertMessage("Error fetching organizations", "error");
        }
    }, [allOrganizationsResponse.isSuccess, allOrganizationsResponse.isError]);

    useEffect(() => {
        if (findAllDepartmentMasterResponse.isSuccess) {
            dispatch(setAllDepartmentMaster(findAllDepartmentMasterResponse))
        } else if (findAllDepartmentMasterResponse.isError) {
            alertMessage("Error while fetching department masters", "error");
        }
    }, [findAllDepartmentMasterResponse.isSuccess, findAllDepartmentMasterResponse.isError]);

    useEffect(() => {
        if (findAllProjectTypeMasterResponse.isSuccess) {
            dispatch(setAllProjectTypeMaster(findAllProjectTypeMasterResponse))
        } else if (findAllProjectTypeMasterResponse.isError) {
            alertMessage("Error while fetching department masters", "error");
        }
    }, [findAllProjectTypeMasterResponse.isSuccess, findAllProjectTypeMasterResponse.isError]);

    useEffect(() => {
        if (findAllProjectMasterResponse.isSuccess) {
            dispatch(setAllProjectMaster(findAllProjectMasterResponse))
            // setFilteredPhase(findAllProjectMasterResponse.data)
        } else if (findAllProjectMasterResponse.isError) {
            alertMessage("Error while fetching project masters", "error");
        }
    }, [findAllProjectMasterResponse.isSuccess, findAllProjectMasterResponse.isError]);

    useEffect(() => {
        if (filteredTimeSheetResponse.isSuccess) {
            dispatch(setTimeSheet(filteredTimeSheetResponse));
        } else if (filteredTimeSheetResponse.isError) {
            alertMessage("Error while fetching filtered time sheet data", "error");
            setDatasource([]);
        }
    }, [filteredTimeSheetResponse.isSuccess, filteredTimeSheetResponse.isError]);


    useEffect(() => {
        if (findAllMenotrsResponse.isSuccess) {
            const uniqueMentors = (findAllMenotrsResponse.data).reduce((acc: any, curr: any) => {
                if (!acc.some((item: any) => item.mentorName === curr.mentorName)) {
                    acc.push(curr);
                }
                return acc;
            }, []);

            dispatch(setAllMentors(uniqueMentors))
        } else if (findAllMenotrsResponse.isError) {
            alertMessage("Error while fetching project masters", "error");
        }
    }, [findAllMenotrsResponse.isSuccess, findAllMenotrsResponse.isError]);

    useEffect(() => {
        if (findAllKRAMasterResponse.isSuccess) {
            dispatch(setAllKRAMaster(findAllKRAMasterResponse))
        } else if (findAllKRAMasterResponse.isError) {
            alertMessage("Error while fetching KRA master", "error");
        }
    }, [findAllKRAMasterResponse.isSuccess, findAllKRAMasterResponse.isError]);

    //data

    useEffect(() => {
        if (departmentMasterData && reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            setDatasource(departmentMasterData);
        }
    }, [departmentMasterData]);

    useEffect(() => {
        if (projectMasterData && reportName === REPORT_NAME.PROJECT_MASTER) {
            setDatasource(projectMasterData);
        }
    }, [projectMasterData]);

    useEffect(() => {
        if (projectTypeMasterData && reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
            setDatasource(projectTypeMasterData);
        }
    }, [projectTypeMasterData]);

    useEffect(() => {
        if (phaseMasterData && reportName === REPORT_NAME.PHASE_MASTER) {
            setDatasource(phaseMasterData);
        }
    }, [phaseMasterData]);

    useEffect(() => {
        if (projectUserMasterData && reportName === REPORT_NAME.PROJECT_USER_MASTER) {
            setDatasource(projectUserMasterData);
        }
    }, [projectUserMasterData]);

    useEffect(() => {
        if (projectPhaseActivityData && reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
            setDatasource(projectPhaseActivityData);
        }
    }, [projectPhaseActivityData]);

    useEffect(() => {
        if (kRAMasterData && reportName === REPORT_NAME.KRA_MASTER) {
            setDatasource(kRAMasterData);
        }
    }, [kRAMasterData]);

    useEffect(() => {
        if (allProject && reportName === REPORT_NAME.TIME_SHEET) {
            const result = allProject.map((project: any) => ({
                projectId: project.id,
                sponsor: project.sponsor
            }));
            setSponsorData(result);
        }
    }, [allProject]);

    useEffect(() => {
        if (timeSheetData && reportName === REPORT_NAME.TIME_SHEET) {
            // setDatasource(timeSheetData);
            const processedData = timeSheetData.map((timeSheet: any) => {
                const totalWorkHours = timeSheet.entriesDTOS
                    ? timeSheet.entriesDTOS.reduce((sum: any, entry: any) => sum + (entry.workHours || 0), 0)
                    : 0;

                return {
                    ...timeSheet,
                    totalWorkHours, // Add the calculated field
                };
            });

            setDatasource(processedData);
        }
    }, [timeSheetData]);

    //deleteResponse responses

    useEffect(() => {
        if (deleteDepartmentMasterResponse.isSuccess) {
            alertMessage("Department master updated successfully", "success");
            setCall("Y");
        } else if (deleteDepartmentMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteDepartmentMasterResponse.isSuccess, deleteDepartmentMasterResponse.isError]);

    useEffect(() => {
        if (deleteProjectMasterResponse.isSuccess) {
            alertMessage("Project master updated successfully", "success");
            setCall("Y");
        } else if (deleteProjectMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteProjectMasterResponse.isSuccess, deleteProjectMasterResponse.isError]);

    useEffect(() => {
        if (deleteProjectTypeMasterResponse.isSuccess) {
            alertMessage("Project type master updated successfully", "success");
            setCall("Y");
        } else if (deleteProjectTypeMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteProjectTypeMasterResponse.isSuccess, deleteProjectTypeMasterResponse.isError]);

    useEffect(() => {
        if (deletePhaseMasterResponse.isSuccess) {
            alertMessage("Phase master updated successfully", "success");
            setCall("Y");
        } else if (deletePhaseMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deletePhaseMasterResponse.isSuccess, deletePhaseMasterResponse.isError]);


    useEffect(() => {
        if (deleteProjectUserMasterResponse.isSuccess) {
            alertMessage("Project user master updated successfully", "success");
            setCall("Y");
        } else if (deleteProjectUserMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteProjectUserMasterResponse.isSuccess, deleteProjectUserMasterResponse.isError]);

    useEffect(() => {
        if (deleteProjectPhaseActivityResponse.isSuccess) {
            alertMessage("Project phase activity updated successfully", "success");
            setCall("Y");
        } else if (deleteProjectPhaseActivityResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteProjectPhaseActivityResponse.isSuccess, deleteProjectPhaseActivityResponse.isError]);

    useEffect(() => {
        if (deleteKRaMasterResponse.isSuccess) {
            alertMessage("Key result area updated successfully", "success");
            setCall("Y");
        } else if (deleteKRaMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteKRaMasterResponse.isSuccess, deleteKRaMasterResponse.isError]);

    useEffect(() => {
        if (deleteTimeSheetResponse.isSuccess) {
            alertMessage("Time sheet updated successfully", "success");
            setCall("Y");
        } else if (deleteTimeSheetResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteTimeSheetResponse.isSuccess, deleteTimeSheetResponse.isError]);

    const handleChange = (e: any) => {

        let { name, value } = e.target;

        setSearchFields((prevFields: any) => {
            const updatedFields = {
                ...prevFields,
                [name]: value,  // Update the field directly based on 'name' and 'value'
            };

            // Call handleSearch with the updated searchFields after a debounce
            setTimeout(() => {
                handleSearch(updatedFields);
            }, 1000);

            return updatedFields;  // Return updated state
        });
    }

    const handleSearch = (searchPayload: any) => {
        getFilteredTimeSheet({
            token: localUserObj.token,
            payload: searchPayload
        })
    }

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            variant="danger"
                            className="d-flex align-items-center me-0 text-nowrap"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {departmentMasterResponse.isLoading ||
                        projectMasterResponse.isLoading ||
                        projectTypeMasterResponse.isLoading ||
                        phaseMasterResponse.isLoading ||
                        projectUserMasterResponse.isLoading ||
                        projectPhaseActivityResponse.isLoading ||
                        kRaMasterResponse.isLoading ||
                        deleteDepartmentMasterResponse.isLoading ||
                        deleteProjectMasterResponse.isLoading ||
                        deleteProjectTypeMasterResponse.isLoading ||
                        deletePhaseMasterResponse.isLoading ||
                        deleteProjectUserMasterResponse.isLoading ||
                        deleteProjectPhaseActivityResponse.isLoading ||
                        deleteKRaMasterResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}

                    {show && (
                        <MasterReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            {reportName === REPORT_NAME.TIME_SHEET && (
                <div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="mt-3">
                                <div className="d-flex">
                                    <div>Department</div>
                                </div>
                                <div className="pe-2">
                                    <select
                                        className="form-select form-select-sm w-100"
                                        aria-label=".form-select-sm example"
                                        onChange={handleChange}
                                        name="department"
                                    >
                                        <option value="">Select Department</option>
                                        {allDepartment && allDepartment.map((itemType: any, index: any) => {
                                            return (
                                                <option
                                                    key={index.toString()}
                                                    value={itemType.name}
                                                >
                                                    {itemType.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="w-100 mt-3">
                                <div className="d-flex">
                                    <div>Organization</div>
                                </div>
                                <div className="pe-2">
                                    <select
                                        className="form-select form-select-sm w-100"
                                        aria-label=".form-select-sm example"
                                        onChange={handleChange}
                                        name="organizationName"
                                    >
                                        <option value="">Select Organization</option>
                                        {organizationData && organizationData.map((itemType: any, index: any) => {
                                            return (
                                                <option
                                                    key={index.toString()}
                                                    value={itemType.name}
                                                >
                                                    {itemType.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="w-100 mt-3">
                                <div className="d-flex">
                                    <div>Project Mentor</div>
                                </div>
                                <div className="pe-2">
                                    <select
                                        className="form-select form-select-sm w-100"
                                        aria-label=".form-select-sm example"
                                        onChange={handleChange}
                                        name="projectMentor"
                                    >
                                        <option value="">Select Mentor</option>
                                        {allMentors && allMentors.map((itemType: any, index: any) => {
                                            return (
                                                <option
                                                    key={index.toString()}
                                                    value={itemType.mentorName}
                                                >
                                                    {itemType.mentorName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="mt-3">
                                <div className="d-flex">
                                    <div>Project Type</div>
                                </div>
                                <div className="pe-2">
                                    <select
                                        className="form-select form-select-sm w-100"
                                        aria-label=".form-select-sm example"
                                        onChange={handleChange}
                                        name="projectType"
                                    >
                                        <option value="">Select Project Type</option>
                                        {allProjectType && allProjectType.map((itemType: any, index: any) => {
                                            return (
                                                <option
                                                    key={index.toString()}
                                                    value={itemType.name}
                                                >
                                                    {itemType.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mt-3">
                                <div className="d-flex">
                                    <div>Sponsor</div>
                                </div>
                                <select
                                    className="form-select form-select-sm w-100"
                                    aria-label=".form-select-sm example"
                                    onChange={handleChange}
                                    name="sponsor"
                                >
                                    <option value="">Select Sponsor</option>
                                    {sponsorData && sponsorData.map((itemType: any, index: any) => {
                                        return (
                                            <option
                                                key={index.toString()}
                                                value={itemType.sponsor}
                                            >
                                                {itemType.sponsor}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            {/* <div className="mt-3">
                                <div className="d-flex">
                                    <div>Auditor Email</div>
                                </div>
                                <input
                                    className="form-control form-control-sm w-100"
                                    type="text"
                                    aria-label=".form-control-sm example"
                                    // onChange={handleChange}
                                    // value={auditorEmail}
                                    name="auditorEmail"
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.DEPARTMENT_MASTER:
                                    return totalDepartmentMaster;
                                case REPORT_NAME.PROJECT_MASTER:
                                    return totalProjectMaster;
                                case REPORT_NAME.PROJECT_TYPE_MASTER:
                                    return totalProjectTypeMaster;
                                case REPORT_NAME.PHASE_MASTER:
                                    return totalPhaseMaster;
                                case REPORT_NAME.PROJECT_USER_MASTER:
                                    return totalProjectUserMaster;
                                case REPORT_NAME.PROJECT_PHASE_ACTIVITY:
                                    return totalProjectPhaseActivity;
                                case REPORT_NAME.KRA_MASTER:
                                    return totalKRAMaster;
                                case REPORT_NAME.TIME_SHEET:
                                    return totalTimeSheet;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default AllMasterReports;